import Modal from "components/Modals/Modal";
import React, { useEffect } from "react";
import { ProcessedLaunchableData } from "../../utils";
import MockLaunchableDeploy from "../../Deploy/Mock";
import { GPUInstanceType } from "components/Environment/Settings/Tabs/Compute/InstanceChanger/GPUTypes";

export interface ArchitectureProps {
  show: boolean;
  setShow: (show: boolean) => void;
  launchableData?: ProcessedLaunchableData;
  instanceObject: GPUInstanceType | null;
  setInstanceObject: (instanceObject: GPUInstanceType | null) => void;
}

export const MockDeployModal: React.FC<ArchitectureProps> = ({
  show,
  setShow,
  launchableData,
  instanceObject,
  setInstanceObject,
}) => {
  useEffect(() => {
    if (show) {
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [show]);

  return (
    <Modal
      isOpen={show}
      setOpen={setShow}
      onClose={() => setShow(false)}
      title={""}
      width={"max-w-7xl"}
      body={
        <div className="relative">
          <MockLaunchableDeploy
            mockData={launchableData}
            instanceObject={instanceObject}
            setInstanceObject={() => {}}
          />
        </div>
      }
      cancelLabel={"Close"}
    />
  );
};
